import { useUpdatePackagingDetails as useFarmUpdatePackagingDetails } from "../../../../../api/farmGate/packaging";
import { useUpdatePackagingDetails as useProcessUpdatePackagingDetails } from "../../../../../api/processGate/packaging";
import { errorView, successMessage } from "../../../../../helpers/ErrorHandler";
import { GateKind, PackagingUnitFieldKey, PackagingUnitSnapshot } from "../types/packagingDetail.types";
import { buildPackagingUnitPayload } from "../utils/packagingDetail.utils";

interface UsePackagingUnitCrudParams {
  packagingId: string;
  gateId: string;
  gateKind: GateKind;
  unitSnapshot: PackagingUnitSnapshot;
  onSaved: () => void;
}

/** Saves one level's unit-count field(s) via the packaging-detail endpoint, always
 * resending the full 6-field snapshot (the API replaces, not patches). */
export const usePackagingUnitCrud = ({
  packagingId,
  gateId,
  gateKind,
  unitSnapshot,
  onSaved
}: UsePackagingUnitCrudParams) => {
  const gateIdKey = gateKind === "farm" ? "farmGateId" : "processGateId";

  const { mutate: farmUpdateDetails } = useFarmUpdatePackagingDetails();
  const { mutate: processUpdateDetails } = useProcessUpdatePackagingDetails();

  const saveUnitField = (fieldKey: PackagingUnitFieldKey, patch: Partial<PackagingUnitSnapshot>) => {
    const payload = {
      data: buildPackagingUnitPayload(fieldKey, unitSnapshot, patch),
      packagingId,
      [gateIdKey]: gateId
    };
    const opts = {
      onSuccess: () => {
        successMessage("Packaging details updated");
        onSaved();
      },
      onError: () => errorView("Failed to update packaging details")
    };
    if (gateKind === "farm") {
      farmUpdateDetails(payload, opts);
    } else {
      processUpdateDetails(payload, opts);
    }
  };

  return { saveUnitField };
};
